<template>
  <div class="">
    <div
      v-for="item in collection"
      :key="item.filename"
      :collectionName="collectionName"
      :config="config"
      :item="item"
    >
      <router-link :to="{ name: 'bingo.show', params: { id: item.slug } }">{{ item.title }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      collection: []
    }
  },

  created () {
    this.collection = this.$store.state
  }
}
</script>

<style>
</style>
